<template>
  <div class="bill-container">
    <van-nav-bar
        title="账单信息"
        left-arrow
        @click-left="onClickLeft"
    >
      <template #right>
      </template>
    </van-nav-bar>
    <div class="nbg">
      <div class="f-box">
        <h2>课程信息</h2>
        <dl>
          <dt>已报名</dt>
          <dd>
            <p>课时：<span>{{ bill.applyBill.hour }}</span></p>
            <p>金额：<span>{{ bill.applyBill.price }}</span></p>
          </dd>
        </dl>
        <dl>
          <dt>已销课</dt>
          <dd>
            <p>课时：<span>{{ bill.signBill.hour }}</span></p>
            <p>金额：<span>{{ bill.signBill.price }}</span></p>
          </dd>
        </dl>
        <dl>
          <dt>未销课</dt>
          <dd>
            <p>课时：<span>{{ parseFloat(bill.applyBill.hour) - parseFloat(bill.signBill.hour) }}</span></p>
            <p>金额：<span>{{ parseFloat(bill.applyBill.price) - parseFloat(bill.signBill.price) }}</span></p>
          </dd>
        </dl>
      </div>

      <div class="f-box">
        <h2>付款信息</h2>
        <dl>
          <dt>已付款</dt>
          <dd>
            <p>金额：<span>{{ bill.payMoney }}</span></p>
          </dd>
        </dl>
        <dl>
          <dt>未付款</dt>
          <dd>
            <p>金额：<span>{{ bill.noPayMoney }}</span></p>
          </dd>
        </dl>
      </div>
      <div class="f-box">
        <h2>退费信息</h2>
        <dl>
          <dt>退费中</dt>
          <dd>
            <p>金额：<span>{{ bill.refundingMoney }}</span></p>
          </dd>
        </dl>
        <dl>
          <dt>已退费</dt>
          <dd>
            <p>金额：<span>{{ bill.refundMoney }}</span></p>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { getBill } from "../../../api/my/bill";

export default {
  name: "BillInfo",
  data() {
    return {
      bill: {
        applyBill: {},
        signBill: {},
        payMoney: 0,
        noPayMoney: 0,
        refundingMoney: 0,
        refundMoney: 0,
      },
    };
  },
  computed: {
    mobile() {
      return this.$store.getters.userInfo.mmobileNum;
    },
  },
  mounted() {
    getBill().then((res) => {
      this.bill = res.result;
    });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.nbg{
  height: 100%;
  background: #f2f6fd;
  padding: 15px;
}
.f-box{
  display: flex;
  background: #ffffff;
  border-radius: 6px;
  flex-direction: column;
  box-shadow: 0px 3px 40px 0px rgba(0, 0, 0, 0.07);
  margin-bottom: 20px;
}
.f-box h2{
  display: flex;
  padding:15px 10px;
  font-size: 15px;
  font-weight:bold;
  border-bottom: 1px solid #ededed;
}
.f-box dl{
  display: flex;
  align-items: center;
  padding:14px 10px;
  border-bottom: 1px solid #ededed;
}
.f-box dl:last-child {
  border-bottom: none;
}
.f-box dl dt{
  display: flex;
  width: 100px;
  align-items: center;
  font-size: 15px;
}
.f-box dl dd{
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
}
.f-box dl dd p{
  margin-left: 10px;
  font-size: 15px;
}
.bill-container {
  padding: 0;
  display: flex;
  height: 100vh;
  flex-direction: column;
}

.van-nav-bar {
  background-color: #4fc08d; /* 设置导航栏背景颜色 */
}

.van-nav-bar__title {
  color: #fff; /* 设置导航栏标题颜色 */
}

.van-nav-bar__arrow {
  color: #fff; /* 设置导航栏返回箭头颜色 */
}

.van-grid-item {
  border-radius: 8px; /* 设置网格项圆角 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 设置网格项阴影 */
  padding: 15px;
  text-align: center;
  background-color: #f5f5f5; /* 设置背景颜色 */
}

.van-grid-item p {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.van-grid-item p:first-child {
  font-size: 16px;
  font-weight: bold;
  color: #4fc08d;
}

.van-grid-item .van-icon {
  font-size: 24px;
  color: #4fc08d;
}

.button-container {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.custom-button {
  margin: 0 10px;
  background-color: #4fc08d;
  border: none;
  transition: background-color 0.3s;
  min-width: 150px; /* 增加按钮宽度 */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  border-radius: 8px; /* 设置按钮圆角 */
}

.custom-button:hover {
  background-color: #45a078;
}

.custom-button .van-icon {
  margin-right: 5px;
}
</style>
